import { DomainModelHelper } from '@digital-platform/shared/domain';
import { CheckList } from '../interfaces/checklist.interface';

export class CheckListModel implements CheckList {
  readonly generatorCheckList: boolean;
  readonly billingCheckList: boolean;
  readonly wasteStreamCheckList: boolean;
  readonly attachmentsCheckList: boolean;
  readonly characteristicsCheckList: boolean;
  readonly destinationCheckList: boolean;
  readonly rcraCheckList: boolean;

  static readonly DEFAULT_CONFIG: CheckList = {
    generatorCheckList: false,
    billingCheckList: false,
    wasteStreamCheckList: false,
    attachmentsCheckList: false,
    characteristicsCheckList: false,
    destinationCheckList: false,
    rcraCheckList: false,
  };

  constructor(config?: CheckList) {
    this.generatorCheckList = config
      ? DomainModelHelper.ensureDataIsBoolean(config.generatorCheckList)
      : false;
    this.billingCheckList = config
      ? DomainModelHelper.ensureDataIsBoolean(config.billingCheckList)
      : false;
    this.wasteStreamCheckList = config
      ? DomainModelHelper.ensureDataIsBoolean(config.wasteStreamCheckList)
      : false;
    this.attachmentsCheckList = config
      ? DomainModelHelper.ensureDataIsBoolean(config.attachmentsCheckList)
      : false;
    this.characteristicsCheckList = config
      ? DomainModelHelper.ensureDataIsBoolean(config.characteristicsCheckList)
      : false;
    this.destinationCheckList = config
      ? DomainModelHelper.ensureDataIsBoolean(config.destinationCheckList)
      : false;
    this.rcraCheckList = config
      ? DomainModelHelper.ensureDataIsBoolean(config.rcraCheckList)
      : false;
  }
}
